import React from 'react'
import AboutUs from 'modules/website/components/AboutUs/AboutUs'
export default function AboutUsView() {
  return (
    <AboutUs/>
  )
}
